<template>
  <v-container
    grid-list-xl
    fluid
    class="pt-0"
    v-if="totalBilling && totalBilling.id && totalBilling.summarize"
  >
    <v-card class="pl-2 pr-2" style="height: 450px">
      <v-card-title primary-title>
        <div>
          <div class="title">Gestão Energética</div>
        </div>
      </v-card-title>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="totalBilling.summarize.energyManagement"
        class="elevation-0"
        hide-actions
      >
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="text-xs-right"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <td>{{ props.item.text }}</td>
          <td class="text-xs-right">{{ props.item.value | formatInt }} kWh</td>
          <td class="text-xs-right">
            {{ props.item.percentage | formatCurrency }}%
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("billing", ["totalBilling"]),
  },
  data: () => ({
    headers: [
      {
        text: "",
        sortable: false,
      },
      { text: "Valor", sortable: false },
      { text: "Percentual", sortable: false },
    ],
  }),
};
</script>
